import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TestService } from 'src/app/services/test.service';
import { ZavicService } from 'src/app/services/zavic.service';
import Swal from 'sweetalert2';

declare var jQuery:any;

@Component({
  selector: 'app-zavic',
  templateUrl: './zavic.component.html',
  styleUrls: []
})

export class ZavicComponent implements OnInit {

  @ViewChild('instructions') instructions: ElementRef;

  public questions;
  public index;
  public answers=[];
  public orderAnswers=[];    ///////[0]=1    la primer pregunta primero [3]=4 la cuarta va ultima
  public actualIndex=0;

  public selectedQuestion:any={
    "title":"",
    "opcA":{"text":""},
    "opcB":{"text":""},
    "opcC":{"text":""},
    "opcD":{"text":""},

  };

  public score = {
    "moral":0,
    "legalidad":0,
    "indiferencia":0,
    "corrupto":0,
    "economico":0,
    "politico":0,
    "social":0,
    "religioso":0,
  }

  public texts;

  constructor(private zavicService: ZavicService, private testService: TestService, private router:Router) {
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
      },
      err=>console.log(err)
    )
    this.zavicService.getQuestions().subscribe(
      resp=>{
        //console.log(resp);
        this.questions=resp;
      },
      err=>{

      }
    )
    if(!this.testService.selectedTestData){

      this.router.navigateByUrl('dashboard/requestedTests');
    }

   }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
        setTimeout(()=>{
          this.instructions.nativeElement.innerHTML = this.texts.zavicInstructions;
        }, 500)
      },
      err=>console.log(err)
    )    

  }

  startTest(){
    this.testService.testStarted = true;

    var testData = this.testService.selectedTestData;
    testData.isStarted = true;
    testData.startDate = Date.now();
    this.testService.updateTest(testData).subscribe();
    
    this.actualIndex = 0;
    this.selectedQuestion = this.questions[0];
    this.index = 0;
    this.score = {
      "moral":0,
      "legalidad":0,
      "indiferencia":0,
      "corrupto":0,
      "economico":0,
      "politico":0,
      "social":0,
      "religioso":0,
    };
    this.orderAnswers[0]=0;
    this.orderAnswers[1]=0;
    this.orderAnswers[2]=0;
    this.orderAnswers[3]=0;

    this.answers = [];
    
  }

  nextQuestion(){

    if(this.actualIndex==4){
      var a = {
        1:this.orderAnswers[0],
        2:this.orderAnswers[1],
        3:this.orderAnswers[2],
        4:this.orderAnswers[3]
      }

      if(this.selectedQuestion.type=="Valores"){

        this.score.moral=this.score.moral+this.orderAnswers[0];
        this.score.legalidad=this.score.legalidad+this.orderAnswers[1];
        this.score.indiferencia=this.score.indiferencia+this.orderAnswers[2];
        this.score.corrupto=this.score.corrupto+this.orderAnswers[3];

      }else{
        this.score.economico=this.score.economico+this.orderAnswers[0];
        this.score.politico=this.score.politico+this.orderAnswers[1];
        this.score.social=this.score.social+this.orderAnswers[2];
        this.score.religioso=this.score.religioso+this.orderAnswers[3];

      }
      this.answers.push(a);
      this.orderAnswers[0]=0;
      this.orderAnswers[1]=0;
      this.orderAnswers[2]=0;
      this.orderAnswers[3]=0;
      this.actualIndex=0;
      this.index = this.index + 1;
      this.selectedQuestion = this.questions[this.index];
      //console.log(this.index);
      //console.log(this.selectedQuestion);
      if(!this.selectedQuestion){

        this.selectedQuestion = {
          "title":"Test finalizado",
          "opcA":{"text":"--"},
          "opcB":{"text":"--"},
          "opcC":{"text":"--"},
          "opcD":{"text":"--"},
          
        }
        //console.log(this.scoreConverted);
  
        Swal.fire({
          text:'Has concluido esta evaluación. Agradecemos tu participación',
          icon:'success',
          confirmButtonText:'Salir'
        });
        jQuery("#myModal").modal("hide");
        this.zavicService.createReport(this.score, this.answers).subscribe(
          res=>{

            var testData = this.testService.selectedTestData;
            testData.isCompleted = true;
            testData.reportId = res._id;
            testData.completeDate = Date.now();
  
            this.testService.updateTest(testData).subscribe(
              r=>{
          
                this.router.navigateByUrl('dashboard/requestedTests');
              },
              e=>console.log(e)
            );
          },
          err=> console.log(err)
        )
        
      }
    }else{
      let timerInterval;
      Swal.fire({
        title: 'Debe seleccionar cuatro opciones',
        html: '',
        timer: 2000,
        timerProgressBar: true,
        
        onClose: () => {
          clearInterval(timerInterval)
        }
      }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
          
        }
      })
    }
  }

  select(opc){

    var added = false;
    if(this.actualIndex<=4){
      for (var i = 0; i<=this.actualIndex; i++){
        if(this.orderAnswers[(parseInt(opc))]!=0){
          added = true;
        }
      }
      if (!added){
        this.orderAnswers[opc]=this.actualIndex+1;
        this.actualIndex++;


      }
    }
  }

  clear(){
    this.orderAnswers[0]=0;
    this.orderAnswers[1]=0;
    this.orderAnswers[2]=0;
    this.orderAnswers[3]=0;
    this.actualIndex=0;
  }

  reload(){
    location.reload()
  }

}
